// src/app/guards/auth.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Auth } from '@angular/fire/auth';
import { onAuthStateChanged } from 'firebase/auth';

export const authGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const afAuth = inject(Auth);

  // 1) Si ya tenemos UID en el servicio, dejamos pasar
  if (authService.uid) {
    return true;
  }

  await authService.initAuth();

  if (authService.uid) {
    return true;
  }  

  // 3) Si no hay usuario, redirigimos
  router.navigateByUrl('/loading');
  return false;
};
